import { z } from 'zod';
import { validator } from '@xeppt/xeppt-sdk';
import { ECardType } from '@xeppt/xeppt-sdk/types/card';
import { TAddress } from '@xeppt/xeppt-sdk/types/user';

export interface IProps {
    currentStep: number;
    cardType?: ECardType;
    isCanadaCitizenship?: boolean;
    isUnemployed?: boolean;
    messages: {
        shipping_address: TAddress;
        first_name: string;
        last_name: string;
        birth_date: string;
        occupation: string;
        employerName: string;
        employerPhone: string;
        employer_address: TAddress;
        billing_address: TAddress;
        cell_phone: string;
        citizenship: string;
        email: string;
        status: string;
    };
}

export const requestCardValidation = ({ currentStep, messages, cardType }: IProps) => {
    const cardholderFields: { [key: string]: any } = {
        first_name: validator.firstName(messages.first_name),
        last_name: validator.lastName(messages.last_name),
        email: validator.email(messages.email),
        middle_name: z.string().optional(),
        alias: z.string().optional(),
        birth_date: validator.birthday(messages.birth_date),
        phone_number: z.string().optional(),
        cell_phone: z.string().min(3, messages.cell_phone),
        permanent_residence: validator.address(messages.billing_address),
        occupation: z.string().min(3, messages.occupation)
    };
    const steps = [
        z.object({
            ...(cardType === ECardType.PHYSICAL_SUPPLEMENTARY && { card_id: z.string() }),
            first_name: validator.firstName(messages.first_name),
            last_name: validator.firstName(messages.last_name)
        }),
        z.object({
            shipping_address: validator.address(messages.shipping_address)
        }),
        z.object(cardholderFields),
        z.object({
            agree: z.boolean().refine((data) => data, {})
        })
    ];
    return steps[currentStep];
};
